export default [
  {
    path: '/work-schedules',
    name: 'work-schedule',
    component: () => import('@/pages/work-schedule/index.vue')
  }
]
